"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAllDislikedTracks = exports.recalculateDislikes = exports.markTaskAsDone = exports.removeDislikeTaskFromInProgress = exports.markDislikeTaskAsInProgress = exports.removeDislikeTaskFromPending = exports.addDislikeTaskToPending = exports.mergeDislikedFiles = exports.setDislikedFiles = void 0;
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var lodash_omit_1 = __importDefault(require("lodash.omit"));
var initialState = {
    disliked: [],
    pending: [],
    inProgress: [],
    totalDislikes: {},
};
function setDislikedFiles() {
    var dislikes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dislikes[_i] = arguments[_i];
    }
    return {
        type: setDislikedFiles.type,
        payload: {
            dislikes: dislikes,
        },
    };
}
exports.setDislikedFiles = setDislikedFiles;
setDislikedFiles.type = "reactions/setDislikedFiles";
function mergeDislikedFiles(dislikes, streamId) {
    return {
        type: mergeDislikedFiles.type,
        payload: {
            dislikes: dislikes,
            streamId: streamId,
        },
    };
}
exports.mergeDislikedFiles = mergeDislikedFiles;
mergeDislikedFiles.type = "reactions/mergeDislikedFiles";
function addDislikeTaskToPending(task) {
    return {
        type: addDislikeTaskToPending.type,
        payload: {
            task: task,
        },
    };
}
exports.addDislikeTaskToPending = addDislikeTaskToPending;
addDislikeTaskToPending.type = "reactions/addDislikeTaskToPending";
function removeDislikeTaskFromPending(task) {
    return {
        type: removeDislikeTaskFromPending.type,
        payload: {
            task: task,
        },
    };
}
exports.removeDislikeTaskFromPending = removeDislikeTaskFromPending;
removeDislikeTaskFromPending.type = "reactions/removeDislikeTaskFromPending";
function markDislikeTaskAsInProgress(task) {
    return {
        type: markDislikeTaskAsInProgress.type,
        payload: {
            task: task,
        },
    };
}
exports.markDislikeTaskAsInProgress = markDislikeTaskAsInProgress;
markDislikeTaskAsInProgress.type = "reactions/markDislikeTaskAsInProgress";
function removeDislikeTaskFromInProgress(task) {
    return {
        type: removeDislikeTaskFromInProgress.type,
        payload: {
            task: task,
        },
    };
}
exports.removeDislikeTaskFromInProgress = removeDislikeTaskFromInProgress;
removeDislikeTaskFromInProgress.type = "reactions/removeDislikeTaskFromInProgress";
function markTaskAsDone(task) {
    return {
        type: markTaskAsDone.type,
        payload: {
            task: task,
        },
    };
}
exports.markTaskAsDone = markTaskAsDone;
markTaskAsDone.type = "reactions/markTaskAsDone";
function recalculateDislikes() {
    return {
        type: recalculateDislikes.type,
        payload: {},
    };
}
exports.recalculateDislikes = recalculateDislikes;
recalculateDislikes.type = "reactions/recalculateDislikes";
function reactionsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case setDislikedFiles.type:
            return __assign(__assign({}, state), { disliked: action.payload.dislikes });
        case mergeDislikedFiles.type:
            return __assign(__assign({}, state), { disliked: __spreadArray(__spreadArray([], __read(state.disliked.filter(function (dislike) { return dislike.streamId !== action.payload.streamId; })), false), __read(action.payload.dislikes), false) });
        case addDislikeTaskToPending.type:
            var opposite_1 = selectOppositeTypeTaskFromPending(state, action.payload.task);
            return __assign(__assign({}, state), { pending: opposite_1
                    ? state.pending.filter(function (task) { return !(0, lodash_isequal_1.default)(task, opposite_1); })
                    : __spreadArray(__spreadArray([], __read(state.pending.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); })), false), [
                        action.payload.task,
                    ], false) });
        case markDislikeTaskAsInProgress.type:
            return __assign(__assign({}, state), { inProgress: __spreadArray(__spreadArray([], __read(state.inProgress), false), [action.payload.task], false) });
        case markTaskAsDone.type:
            var disliked = __spreadArray([], __read(state.disliked.filter(function (dislike) { return !(0, lodash_isequal_1.default)(dislike, (0, lodash_omit_1.default)(action.payload.task, "type")); })), false);
            if (action.payload.task.type === "dislike") {
                disliked.push((0, lodash_omit_1.default)(action.payload.task, "type"));
            }
            return {
                pending: state.pending.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); }),
                inProgress: state.inProgress.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); }),
                disliked: disliked,
                totalDislikes: state.totalDislikes,
            };
        case removeDislikeTaskFromPending.type:
            return __assign(__assign({}, state), { pending: state.pending.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); }), inProgress: state.inProgress.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); }) });
        case removeDislikeTaskFromInProgress.type:
            return __assign(__assign({}, state), { inProgress: state.inProgress.filter(function (task) { return !(0, lodash_isequal_1.default)(task, action.payload.task); }) });
        case recalculateDislikes.type:
            return __assign(__assign({}, state), { totalDislikes: selectAllDislikedTracks(state) });
        default:
            return state;
    }
}
exports.default = reactionsReducer;
function selectOppositeTypeTaskFromPending(state, task) {
    var oppositeType = task.type === "dislike" ? "restore-dislike" : "dislike";
    var same = state.pending.filter(function (pendingTask) {
        return (0, lodash_isequal_1.default)((0, lodash_omit_1.default)(pendingTask, "type"), (0, lodash_omit_1.default)(task, "type"));
    });
    var opposite = same.find(function (sTask) { return sTask.type === oppositeType; });
    var inProgress = state.inProgress.find(function (inPtask) { return (0, lodash_isequal_1.default)(inPtask, opposite); });
    if (inProgress) {
        return undefined;
    }
    return opposite;
}
function selectAllDislikedTracks(state) {
    var pending = state.pending;
    var dislikes = state.disliked;
    var pendingRestores = pending
        .filter(function (item) { return item.type === "restore-dislike"; })
        .map(function (item) { return "".concat(item.id, "/").concat(item.streamId); });
    var pendingDislikes = pending.filter(function (item) { return item.type === "dislike"; });
    return __spreadArray(__spreadArray([], __read(dislikes), false), __read(pendingDislikes), false).reduce(function (collect, curr) {
        var key = "".concat(curr.id, "/").concat(curr.streamId);
        if (!pendingRestores.includes(key)) {
            collect[key] = true;
        }
        return collect;
    }, {});
}
exports.selectAllDislikedTracks = selectAllDislikedTracks;
//# sourceMappingURL=reactions.js.map